import type { ZodType } from 'zod'

export enum ValidateOn {
  CHANGE = 'change',
  BLUR = 'blur',
  SUBMIT = 'submit',
}

export interface FormValidationOptions {
  validateOn?: ValidateOn
  initValidation?: boolean
  formSchema?: ZodType
}

export interface FormInputValidationOptions extends FormValidationOptions {
  label?: string
}

export interface FormInputValidation<T = unknown> {
  schema: ZodType<T>
  value: T
  validateOn?: ValidateOn
  label?: string
}
